// The site header reads who is signed in once, when the page opens. A person who signs in or out without the page reloading (the
// code that publishes a listing signs them in, for one) tells the header here, and it reads again.
export const SESSION_CHANGED_EVENT = 'rec:session-changed';

export function announceSessionChange() {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(SESSION_CHANGED_EVENT));
}
